/////////////////////////////////////////////
// DEFAULT PROPS FOR COMPONENTS
/////////////////////////////////////////////

export const FONT_FAMILY = {
  heading: `'Poppins', sans-serif;`,
  subHeading: `'Poppins', sans-serif;`,
  body: `'Inter', sans-serif;`,
  body_lv2: `'Poppins', sans-serif;`,
  fullName: `'Poppins', sans-serif;`,
};

export const TEXT_PROPS = {
  heading: {
    fontFamily: 'heading',
    fontSize: 'heading',
    fontWeight: 'heading',
    fontStyle: 'var(--fontItalic-heading)',
    textAlign: 'center',
  },
  subHeading: {
    fontFamily: 'subHeading',
    fontSize: 'subHeading',
    fontWeight: 'subHeading',
    fontStyle: 'var(--fontItalic-subHeading)',
    textAlign: 'center',
    letterSpacing: '3px',
    textTransform: 'uppercase',
  },
  body: {
    fontFamily: 'body',
    fontSize: 'body',
    fontWeight: 'body',
    fontStyle: 'var(--fontItalic-body)',
    textAlign: 'center',
  },
  body_lv2: {
    fontFamily: 'body_lv2',
    fontSize: 'body_lv2',
    fontWeight: 'body_lv2',
    fontStyle: 'var(--fontItalic-body_lv2)',
    textAlign: 'center',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  fullNameProps: {
    fontFamily: 'fullName',
    fontSize: 'fullName',
    fontWeight: 'fullName',
    fontStyle: 'var(--fontItalic-fullName)',
    letterSpacing: '3px',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
};

export const PRIMARY_BUTTON_PROPS = {
  ...TEXT_PROPS.body,
  size: 'sm',
  fontSize: '14px',
  fontWeight: 'normal',
  bgColor: 'bgAlternative',
  color: 'mainColorTextLight',
  fontStyle: 'italic',
  _active: { opacity: '0.9' },
  _hover: { opacity: '0.7' },
};

export const SECONDARY_BUTTON_PROPS = {
  ...PRIMARY_BUTTON_PROPS,
  bgColor: 'bgSecondary',
  color: 'secondaryColorText',
};
